
import { Component, Vue, Prop } from 'vue-property-decorator'
import { StatusMap } from '../config/auth'
import StatusDot from '@/components/status_dot/index.vue'

/**
 * @prop value  表格数据
*/
@Component({
    name: 'auth-table',
    components: {
        StatusDot
    }
})
export default class extends Vue {
    @Prop({ required: true }) private value!: any[]

    private getStatus(status: number, type: 'text' | 'status') {
        const typeItem = StatusMap.get(status)
        if (!typeItem) return ''
        if (type === 'text') {
            return typeItem.value
        } else if (type === 'status') {
            return typeItem.status
        } else {
            return ''
        }
    }
}
